<div class="palantir-list-item">
  <palantir-content>
    <palantir-toolbar>
      <palantir-toolbar-prefix>
        <ng-content select="[palantir-list-item-prefix], palantir-list-item-prefix" />

        <palantir-toolbar-content>
          <ng-content select="[palantir-list-item-content], palantir-list-item-content" />
        </palantir-toolbar-content>
      </palantir-toolbar-prefix>

      <palantir-toolbar-suffix>
        <ng-content select="[palantir-list-item-suffix], palantir-list-item-suffix" />
      </palantir-toolbar-suffix>
    </palantir-toolbar>
  </palantir-content>
</div>

<div class="palantir-list-item-children" #children>
  <ng-content />
</div>
